export default (value) => {
  let localValue = Number(value);

  if (!localValue) {
    localValue = 0;
  }

  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(localValue);
};
